import { render, staticRenderFns } from "./FixtureResult.vue?vue&type=template&id=a2e6c93c&"
import script from "./FixtureResult.vue?vue&type=script&lang=js&"
export * from "./FixtureResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports